enum issuerCardActions {
  deleteIssuerCards = "DeleteIssuerCards",
  createIssuerCards = "CreateIssuerCards",
  updateIssuerCards = "UpdateIssuerCards"
}

export {
  issuerCardActions
}
